export default __webpack_public_path__ + "static/media/icon_story.0890f56b.svg";